import dayjs from 'dayjs'

import type { DayjsRange, StatisticsRangePreset } from './types/common'

export const getPrevStatisticsRange = (
  range: DayjsRange,
  type: StatisticsRangePreset,
): DayjsRange => {
  switch (type) {
    case 'day':
      return {
        start: (range.start ?? dayjs()).subtract(1, 'day').startOf('day'),
        end: (range.start ?? dayjs()).subtract(1, 'day').endOf('day'),
      }
    case 'week':
      return {
        start: (range.start ?? dayjs()).subtract(1, 'week').startOf('week'),
        end: (range.start ?? dayjs()).subtract(1, 'week').endOf('week'),
      }
    case 'month':
      return {
        start: (range.start ?? dayjs()).subtract(1, 'month').startOf('month'),
        end: (range.start ?? dayjs()).subtract(1, 'month').endOf('month'),
      }
    default:
      return { allTime: true }
  }
}

export const getNextStatisticsRange = (
  range: DayjsRange,
  type: StatisticsRangePreset,
): DayjsRange => {
  switch (type) {
    case 'day':
      return {
        start: (range.start ?? dayjs()).add(1, 'day').startOf('day'),
        end: (range.start ?? dayjs()).add(1, 'day').endOf('day'),
      }
    case 'week':
      return {
        start: (range.start ?? dayjs()).add(1, 'week').startOf('week'),
        end: (range.start ?? dayjs()).add(1, 'week').endOf('week'),
      }
    case 'month':
      return {
        start: (range.start ?? dayjs()).add(1, 'month').startOf('month'),
        end: (range.start ?? dayjs()).add(1, 'month').endOf('month'),
      }
    default:
      return { allTime: true }
  }
}
